import React, { useState } from "react";

import { useHistory } from "react-router-dom";

import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";

import Authentication from "../../../../../../infra/cognito/authentication";

import Login from "../../../../../../presentation/pages/auth/developer/login";

import toastUtils from "../../../../../../utils/ToastUtils";
import { t } from "../../../../../../presentation/adapters/translate/translate";

function MakeSignIn(): JSX.Element {
  const rememberMe = localStorage.getItem("rememberMe");

  const history = useHistory();

  const [errorMessage] = useState<string | null>("");

  const { reloadAuth } = useAuthGlobal();

  const handleSubmit = async (values: any): Promise<void> => {
    if (values?.rememberMe[0]) {
      localStorage.setItem("rememberMe", values?.email);
    } else {
      localStorage.removeItem("rememberMe");
    }

    try {
      const res: any = await Authentication.login(
        values.email,
        values.password,
      );

      if (res.challengeName === "NEW_PASSWORD_REQUIRED") {
        toastUtils.showMessage({
          type: "warning",
          message:
            "Você será redirecionado em alguns instantes para alterar sua senha",
        });

        setTimeout(() => {
          history.push("/developer/new-password");
        }, 3000);
        return;
      }
    } catch (error: any) {
      toastUtils.showMessage({
        type: "error",
        message: t(error.code, error.message),
      });
    } finally {
      reloadAuth();
    }
  };

  // This will be fixed in the future, please do not remove this code

  const loginLinkedin = async (
    evt: React.MouseEvent<HTMLButtonElement>,
  ): Promise<void> => {
    evt.preventDefault();
    try {
      await Authentication.loginLinkedin();
    } catch (error: any) {
      console.error(error);
    }
  }; 

  const handleRememberMeChange = (value: any, el: any): void => {
    if (value[0]) {
      localStorage.setItem("rememberMe", el?.values?.email);
    } else {
      localStorage.removeItem("rememberMe");
    }
  };

  const dataForm = [
    {
      items: [
        {
          component: "Input",
          name: "email",
          title: "E-mail",
          label: "E-mail",
          value: rememberMe ?? "",
          validations: "inputRequired",
        },
        {
          component: "InputPassword",
          type: "password",
          name: "password",
          title: "Senha",
          label: "Senha",
          validations: "inputRequired",
        },
        {
          component: "InputGroup",
          style: {
            display: "grid",
            gridTemplateColumns: "1fr 1.5fr",
          },
          inputs: [
            {
              component: "InputCheck",
              name: "rememberMe",
              title: "",
              label: "",
              onChange: handleRememberMeChange,
              checked: rememberMe ?? false,
              options: [
                {
                  value: "true",
                  label: "Lembrar-me",
                  name: "Lembrar-me",
                },
              ],
            },
            {
              component: "Link",
              title: "Esqueci minha senha",
              href: "/developer/forgot-password",
            },
          ],
        },
        {
          component: "InputGroup",
          style: {
            display: "flex",
            gap: "16px",
            width: "100%",
            flexDirection: "column",
          },
          inputs: [
            {
              name: "button",
              component: "Button",
              title: "Entrar",
              submittingText: "Entrando...",
            },

            // This will be fixed in the future, please do not remove this code
              {
              name: "linkedinButton",
              component: "Button",
              type: "button",
              title: "Login com Linkedin",
              onClick: loginLinkedin,
              style: {
                backgroundColor: "white",
              },
              submittingText: "Entrando...",
              icon: "linkedin",
            }, 
          ],
        },
      ],
    },
  ];

  const props = {
    dataForm,
    errorMessage,
    onSubmit: handleSubmit,
  };

  return <Login {...props} />;
}

export default MakeSignIn;
